<template>
  <a-card :bordered="false">
    <a-row :gutter="24">
      <a-col :span="24">
        <!-- 条件搜索区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="[16, 8]">
              <!-- 中文名称搜索 -->
              <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
                <a-form-item label="中文名称">
                  <a-input
                    v-model:value="queryParam.deptName"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>
              <!-- 公司简称搜索 -->
              <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
                <a-form-item label="公司简称">
                  <a-input
                    v-model:value="queryParam.companyAbbreviation"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>
              <!-- 公司代码搜索 -->
              <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
                <a-form-item label="公司代码">
                  <a-input
                    v-model:value="queryParam.code"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>

              <!-- 按钮区域：默认在第一行，展开后在最后一行 -->
              <a-col v-if="!advanced" :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
                <a-form-item>
                  <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                    <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                    <a-button style="margin-left: 8px" @click="resetQuery" class="no-border-button">重置</a-button>
                    <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                      {{ advanced ? '收起' : '展开' }}
                      <UpOutlined v-if="advanced" />
                      <DownOutlined v-else />
                    </a-button>
                  </span>
                </a-form-item>
              </a-col>

              <!-- 高级搜索区域 -->
              <template v-if="advanced">
                <!-- 英文名称搜索 -->
                <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
                  <a-form-item label="英文名称">
                    <a-input
                      v-model:value="queryParam.englishName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <!-- 地址搜索 -->
                <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
                  <a-form-item label="地址">
                    <a-input
                      v-model:value="queryParam.address"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <!-- 联系人搜索 -->
                <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
                  <a-form-item label="联系人">
                    <a-input
                      v-model:value="queryParam.leader"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <!-- 电话搜索 -->
                <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
                  <a-form-item label="电话">
                    <a-input
                      v-model:value="queryParam.phone"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>

                <!-- 展开后，按钮在最后一行 -->
                <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
                  <a-form-item>
                    <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                      <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                      <a-button style="margin-left: 8px" @click="resetQuery" class="no-border-button">重置</a-button>
                      <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                        {{ advanced ? '收起' : '展开' }}
                        <UpOutlined v-if="advanced" />
                        <DownOutlined v-else />
                      </a-button>
                    </span>
                  </a-form-item>
                </a-col>
              </template>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operations">
          <a-button
            type="text"
            shape="circle"
            @click="getList"
            v-hasPermi="['system:dept:refresh']"
            class="refresh-icon-button"
          >
            <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
          </a-button>
          <a-button
            type="primary"
            @click="handleRefreshBaiduToken"
            v-hasPermi="['system:dept:refreshToken']"
            class="add-button"
          >
            <a-icon type="sync" />刷新百度token
          </a-button>
          <a-button
            type="primary"
            @click="$refs.createForm.handleAdd()"
            v-hasPermi="['system:dept:add']"
            class="add-button"
          >
            <a-icon type="plus" />新增
          </a-button>
          <a-button @click="handleExport" v-hasPermi="['system:dept:export']" class="no-border-button export-button">
            <a-icon type="download" />导出
          </a-button>
          <a-button
            @click="$refs.importExcel.importExcelHandleOpen()"
            v-hasPermi="['system:dept:import']"
            class="no-border-button import-button"
          >
            <a-icon type="import" />导入
          </a-button>
          <a-button
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['system:dept:remove']"
            class="no-border-button"
          >
            <a-icon type="delete" />删除
          </a-button>
          <a-button
            @click="handleDownloadTemplate"
            v-hasPermi="['system:dept:importTemplate']"
            class="no-border-button template-download-button"
          >
            <CloudDownloadOutlined />导入模板下载
          </a-button>
          <!-- 表格设置 -->
          <!-- <table-setting
            :style="{ float: 'right' }"
            v-model:table-size="tableSize"
            v-model:value="columns"
            :refresh-loading="loading"
            @refresh="getList"
          /> -->
        </div>
        <!-- 创建/编辑表单组件 -->
        <create-form
          ref="createForm"
          :deptOptions="deptOptions"
          @ok="getList"
          @close="getList"
          @select-tree="getTreeselect"
        />
        <!-- 导入Excel组件 -->
        <importExcel ref="importExcel" @ok="getList" />
        <!-- 数据表格 -->
        <div style="margin-top: 20px">
          <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="columns"
            :scroll="{ x: true }"
            :data-source="list"
            :pagination="false"
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
            }"
            :bordered="tableBordered"
            class="optimized-table"
          >
            <template #bodyCell="{ column, record, index }">
              <!-- 序号列 -->
              <template v-if="column.dataIndex === 'index'">
                <span>{{
                  (queryParam.pageNum - 1) * queryParam.pageSize +
                  (index !== undefined && index !== null ? index : list.findIndex((item) => item.id === record.id)) +
                  1
                }}</span>
              </template>
              <!-- 操作列 -->
              <template v-else-if="column.dataIndex === 'operation'">
                <div class="table-action-buttons">
                  <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['system:dept:edit']" class="edit-link">
                    编辑
                  </a>
                </div>
              </template>
            </template>
          </a-table>
        </div>
        <!-- 分页组件 -->
        <div class="pagination-wrapper">
          <div class="pagination-left">
            <span class="pagination-info">
              显示第 {{ (queryParam.pageNum - 1) * queryParam.pageSize + 1 }} 到第
              {{ Math.min(queryParam.pageNum * queryParam.pageSize, total) }} 条数据/共 {{ total }} 条
            </span>
            <a-select
              v-model:value="queryParam.pageSize"
              style="width: 100px; margin-left: 8px"
              @change="onShowSizeChange(queryParam.pageNum, queryParam.pageSize)"
              class="no-border-radius-select"
            >
              <a-select-option :value="10">10条/页</a-select-option>
              <a-select-option :value="20">20条/页</a-select-option>
              <a-select-option :value="50">50条/页</a-select-option>
              <a-select-option :value="100">100条/页</a-select-option>
            </a-select>
          </div>
          <div class="pagination-right">
            <a-pagination
              :current="queryParam.pageNum"
              :total="total"
              :page-size="queryParam.pageSize"
              :show-total="false"
              @change="changeSize"
            />
            <span class="pagination-jump">
              到第
              <a-input-number
                v-model:value="jumpPage"
                :min="1"
                :max="Math.ceil(total / queryParam.pageSize)"
                style="width: 60px; margin: 0 4px"
                @pressEnter="handleJumpPage"
                class="no-border-radius-input-number"
              />
              页
            </span>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
/**
 * 公司机构管理页面
 * 功能：提供公司机构的查询、新增、编辑、删除、导入导出等功能
 * - 支持按中文名称、公司简称、公司代码、英文名称、地址、联系人、电话等条件搜索
 * - 支持高级搜索展开/收起
 * - 支持批量删除
 */
import { pageDept, listDept, delDept, listDeptExcludeChild, refreshBaiduToken } from '@/api/system/dept'
import CreateForm from './modules/CreateForm'
import importExcel from './modules/ImportExcel'
import { tableMixin } from '@/store/table-mixin'
import { SearchOutlined, RedoOutlined, UpOutlined, DownOutlined, CloudDownloadOutlined } from '@ant-design/icons-vue'

export default {
  name: 'Dept',
  components: {
    CreateForm,
    importExcel,
    SearchOutlined,
    RedoOutlined,
    UpOutlined,
    DownOutlined,
    CloudDownloadOutlined,
  },
  mixins: [tableMixin],
  data() {
    return {
      // 选中的行key数组
      selectedRowKeys: [],
      // 选中的行数据数组
      selectedRows: [],
      // 选中的ID数组（用于批量删除、导出等操作）
      ids: [],
      // 高级搜索展开/关闭状态
      advanced: false,
      // 非多个禁用（用于控制批量操作的按钮状态）
      multiple: true,
      // 机构列表数据
      list: [],
      // 总记录数
      total: 0,
      // 部门树选项（用于创建/编辑表单）
      deptOptions: [],
      // 加载状态
      loading: false,
      // 跳转页码
      jumpPage: 1,
      // 查询参数（包含所有搜索字段和分页参数）
      queryParam: {
        deptName: undefined, // 中文名称
        companyAbbreviation: undefined, // 公司简称
        code: undefined, // 公司代码
        englishName: undefined, // 英文名称
        address: undefined, // 地址
        leader: undefined, // 联系人
        phone: undefined, // 电话
        pageNum: 1, // 当前页码
        pageSize: 10, // 每页条数
      },
      // 表格列配置
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
          width: 80,
        },
        {
          title: '中文名称',
          dataIndex: 'deptName',
          align: 'center',
        },
        {
          title: '公司简称',
          dataIndex: 'companyAbbreviation',
          align: 'center',
        },
        {
          title: '公司代码',
          dataIndex: 'code',
          align: 'center',
        },
        {
          title: '英文名称',
          dataIndex: 'englishName',
          align: 'center',
        },
        {
          title: '地址',
          dataIndex: 'address',
          align: 'center',
          ellipsis: true,
        },
        {
          title: '联系人',
          dataIndex: 'leader',
          align: 'center',
        },
        {
          title: '电话',
          dataIndex: 'phone',
          align: 'center',
        },
        {
          title: '签约时间',
          dataIndex: 'startTime',
          align: 'center',
        },
        {
          title: '服务截止时间',
          dataIndex: 'endTime',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          align: 'center',
        },
      ],
    }
  },
  computed: {
    /**
     * 提交按钮样式
     */
    submitButtonStyle() {
      return this.advanced ? { float: 'right', overflow: 'hidden' } : {}
    },
  },
  created() {
    // 初始化时获取机构列表
    this.getList()
  },
  methods: {
    /**
     * 切换高级搜索展开/收起
     */
    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    /**
     * 每页条数变化
     * @param {Number} current - 当前页码
     * @param {Number} pageSize - 每页条数
     */
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.queryParam.pageNum = 1
      this.jumpPage = 1
      this.getList()
    },

    /**
     * 分页变化
     * @param {Number} current - 当前页码
     * @param {Number} pageSize - 每页条数
     */
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.jumpPage = current
      this.getList()
    },

    /**
     * 表格行选择变化
     * @param {Array} selectedRowKeys - 选中的行key数组
     * @param {Array} selectedRows - 选中的行数据数组
     */
    onSelectChange(selectedRowKeys, selectedRows) {
      console.log('onSelectChange 被调用:', { selectedRowKeys, selectedRows })
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows || []

      // 直接使用 selectedRowKeys，因为表格的 rowKey="id"，所以 selectedRowKeys 就是 ID 数组
      this.ids = selectedRowKeys || []
      console.log('更新后的 this.ids:', this.ids)

      // 更新按钮禁用状态
      this.multiple = !selectedRowKeys.length
    },

    /**
     * 导出按钮操作
     * 导出当前筛选条件下的全部数据（如果选中了数据，则传递ids参数）
     */
    handleExport() {
      const that = this
      const hasSelection = that.ids && that.ids.length > 0
      this.$confirm({
        title: '是否确认导出?',
        content: hasSelection ? '将导出所选数据' : '将导出当前筛选条件下的全部数据',
        onOk() {
          const params = {
            ...that.queryParam,
          }
          // 如果选中了数据，则传递ids参数
          if (hasSelection) {
            params.ids = that.ids
          }
          that.download('system/dept/export', params, `公司机构_${new Date().getTime()}.xlsx`)
        },
        onCancel() {},
      })
    },

    /**
     * 下载导入模板
     */
    handleDownloadTemplate() {
      this.download('system/dept/importTemplate', {}, `公司机构_${new Date().getTime()}.xlsx`)
    },

    /**
     * 刷新百度 token：调用接口获取新 access_token 并保存
     */
    handleRefreshBaiduToken() {
      this.$confirm({
        title: '确认刷新',
        content: '将向百度请求新的 access_token 并保存，是否继续？',
        onOk: () => {
          refreshBaiduToken()
            .then(() => {
              this.$message.success('刷新百度token成功')
            })
            .catch((err) => {
              this.$message.error(err?.msg || '刷新百度token失败')
            })
        },
      })
    },

    /**
     * 查询机构列表
     * 根据查询参数分页获取机构数据
     */
    getList() {
      this.loading = true
      pageDept(this.queryParam)
        .then((response) => {
          this.list = response.data.records
          this.total = response.data.total
          this.jumpPage = this.queryParam.pageNum
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    /**
     * 查询部门下拉树结构
     * 获取部门树数据，用于创建/编辑表单
     * @param {Object} row - 行数据对象（可选，如果传入则排除该节点及其子节点）
     */
    getTreeselect(row) {
      if (!row) {
        // 获取全部部门树
        listDept().then((response) => {
          this.deptOptions = this.handleTree(response.data, 'id')
        })
      } else {
        // 排除指定节点及其子节点
        listDeptExcludeChild(row.id).then((response) => {
          this.deptOptions = this.handleTree(response.data, 'id')
        })
      }
    },

    /**
     * 搜索按钮操作
     * 重置到第一页并重新查询
     */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.jumpPage = 1
      this.getList()
    },

    /**
     * 跳转页面
     */
    handleJumpPage() {
      if (this.jumpPage && this.jumpPage >= 1) {
        const maxPage = Math.ceil(this.total / this.queryParam.pageSize)
        if (this.jumpPage > maxPage) {
          this.jumpPage = maxPage
        }
        this.queryParam.pageNum = this.jumpPage
        this.getList()
      }
    },

    /**
     * 重置按钮操作
     * 清空所有查询条件，保留分页参数
     */
    resetQuery() {
      this.queryParam = {
        deptName: undefined, // 中文名称
        companyAbbreviation: undefined, // 公司简称
        code: undefined, // 公司代码
        englishName: undefined, // 英文名称
        address: undefined, // 地址
        leader: undefined, // 联系人
        phone: undefined, // 电话
        pageNum: 1, // 当前页码
        pageSize: 10, // 每页条数
      }
      this.handleQuery()
    },

    /**
     * 删除按钮操作
     * @param {Object} row - 要删除的机构记录（可选，如果传入则删除单条，否则删除选中的多条）
     */
    handleDelete(row) {
      const that = this

      // 获取要删除的ID列表
      let deptIds = []
      if (row) {
        // 单条删除
        deptIds = [row.id]
      } else {
        // 批量删除：直接从selectedRows中获取ID
        if (this.selectedRows && this.selectedRows.length > 0) {
          deptIds = this.selectedRows.map((item) => (item && item.id ? item.id : null)).filter((id) => id !== null)
        } else if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
          // 如果selectedRows为空，使用selectedRowKeys
          deptIds = this.selectedRowKeys
        } else if (this.ids && this.ids.length > 0) {
          // 最后备选：使用this.ids
          deptIds = this.ids
        }
      }

      if (!deptIds || deptIds.length === 0) {
        this.$message.warning('请先选择要删除的数据', 3)
        return
      }

      // 获取勾选的表格数据（直接从selectedRows中获取）
      let selectedData = []

      if (row) {
        // 单条删除，直接使用row
        selectedData = [row]
      } else {
        // 批量删除：直接从selectedRows中获取（这是用户勾选的表格项，包含完整数据）
        if (this.selectedRows && this.selectedRows.length > 0) {
          selectedData = this.selectedRows
        } else if (this.list && this.list.length > 0 && this.selectedRowKeys && this.selectedRowKeys.length > 0) {
          // 如果selectedRows为空，从list中根据selectedRowKeys查找（备选方案）
          selectedData = this.selectedRowKeys
            .map((key) => {
              return this.list.find((item) => {
                if (!item || item.id === undefined) return false
                // 处理类型不匹配
                return item.id === key || String(item.id) === String(key) || Number(item.id) === Number(key)
              })
            })
            .filter((item) => item !== null && item !== undefined)
        }
      }

      // 打印勾选的表格数据
      console.log('=== 勾选的表格数据 ===')
      console.log('selectedRows:', this.selectedRows)
      console.log('selectedRowKeys:', this.selectedRowKeys)
      console.log('selectedData:', selectedData)
      console.log('this.ids:', this.ids)
      console.log('this.ids 类型:', Array.isArray(this.ids) ? 'Array' : typeof this.ids)
      console.log('this.ids 长度:', this.ids ? this.ids.length : 0)

      // 从selectedData中获取公司名称（deptName字段）
      // 直接使用forEach遍历，确保能正确访问Proxy对象的属性
      const deptNames = []

      if (selectedData && selectedData.length > 0) {
        selectedData.forEach((item) => {
          try {
            // 直接访问deptName属性
            if (item && item.deptName) {
              deptNames.push(String(item.deptName))
            }
          } catch (e) {
            console.warn('获取deptName失败:', e, item)
          }
        })
      }

      // 如果selectedData中没有获取到，直接从this.selectedRows获取
      if (deptNames.length === 0 && this.selectedRows && this.selectedRows.length > 0) {
        this.selectedRows.forEach((item) => {
          try {
            if (item && item.deptName) {
              deptNames.push(String(item.deptName))
            }
          } catch (e) {
            console.warn('从selectedRows获取deptName失败:', e, item)
          }
        })
      }

      // 获取实际选中的条数：使用selectedRows.length
      const selectedCount = this.selectedRows.length || 0

      this.$confirm({
        title: '确认删除所选中数据?',
        content: `当前选中公司名称为 ${
          deptNames.length > 0 ? deptNames.join('、') : '未知'
        } 的数据，共 ${selectedCount} 条`,
        onOk() {
          // 直接使用 selectedRowKeys，因为表格的 rowKey="id"，所以 selectedRowKeys 就是 ID 数组
          if (!that.selectedRowKeys || !Array.isArray(that.selectedRowKeys) || that.selectedRowKeys.length === 0) {
            that.$message.warning('请先选择要删除的数据', 3)
            return Promise.resolve()
          }

          // 转换为 [{id: xxx}, {id: xxx}] 格式
          const data = that.selectedRowKeys.map((id) => ({ id: String(id) }))

          return delDept(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('删除成功', 3)
            })
            .catch(() => {
              that.$message.error('删除失败', 3)
            })
        },
        onCancel() {},
      })
    },
  },
}
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 80px;
  min-width: 80px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 80px;
  text-align: right;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 - 优先级高于 no-border-radius-input */
/* 普通输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input:not(.ant-input-affix-wrapper .ant-input)) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框外层样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 通用规则：当 input 在 affix-wrapper 内时，必须去掉边框避免嵌套 - 最高优先级 */
/* 覆盖所有边框相关属性 */
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper > .ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper input.ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:hover),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:focus),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.ant-form-item .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input-content .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper input.ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input[type='text']) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

/* 移除搜索栏输入框聚焦时的高亮效果 */
/* 输入框聚焦样式 - 内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-focused) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 带前缀/后缀的输入框聚焦样式 - 外部容器保持边框，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 聚焦时，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 下拉选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector:focus),
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-focused .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector:focus),
.table-page-search-wrapper :deep(.ant-select-focused .ant-select-selector) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker:focus),
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker-focused),
.table-page-search-wrapper :deep(.ant-picker:focus),
.table-page-search-wrapper :deep(.ant-picker-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.table-page-search-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #ffffff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165dff !important;
  border-color: #165dff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #ffffff !important;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

.no-border-button:hover:not(:disabled),
.no-border-button:focus:not(:disabled) {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

/* 禁用状态样式 */
.no-border-button:disabled,
.no-border-button[disabled] {
  border: none !important;
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed !important;
}

.no-border-button:disabled:hover,
.no-border-button:disabled:focus,
.no-border-button[disabled]:hover,
.no-border-button[disabled]:focus {
  border: none !important;
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
}

/* 展开/收起按钮文字和图标颜色，去掉底部阴影 */
.toggle-button {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

/* 导入导出按钮背景颜色 */
.import-button,
.export-button {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-button :deep(.anticon),
.export-button :deep(.anticon) {
  color: #333 !important;
}

.import-button:hover,
.export-button:hover {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-button:hover :deep(.anticon),
.export-button:hover :deep(.anticon) {
  color: #333 !important;
}

.import-button:focus,
.export-button:focus {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-button:focus :deep(.anticon),
.export-button:focus :deep(.anticon) {
  color: #333 !important;
}

/* 导入模板下载按钮文字和图标颜色，去掉底部阴影 */
.template-download-button {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.template-download-button :deep(.anticon) {
  color: #165dff !important;
}

.template-download-button:hover,
.template-download-button:focus {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.template-download-button:hover :deep(.anticon),
.template-download-button:focus :deep(.anticon) {
  color: #165dff !important;
}

.toggle-button :deep(.anticon) {
  color: #165dff !important;
}

.toggle-button:hover,
.toggle-button:focus {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165dff !important;
}

.table-action-buttons a {
  color: #1890ff;
  cursor: pointer;
  white-space: nowrap; /* 防止操作按钮换行 */
}

.table-action-buttons a:hover {
  color: #40a9ff;
}

/* 编辑按钮颜色 */
.table-action-buttons .edit-link {
  color: #165dff !important;
}

.table-action-buttons .edit-link:hover {
  color: #4080ff !important;
}

.action-divider {
  margin: 0 8px;
  color: #d9d9d9;
  white-space: nowrap;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.refresh-icon-button img {
  width: 32px;
  height: 32px;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap; /* 表头不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap; /* 表格内容不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px; /* 增加内边距 */
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 操作列固定右侧样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child) {
  position: sticky;
  right: 0;
  background: white;
  z-index: 1;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-thead > tr > th:last-child) {
  position: sticky;
  right: 0;
  background: #fafafa;
  z-index: 2;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* Confirm 弹窗按钮样式 */
:deep(.ant-modal-confirm .ant-btn) {
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-default) {
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-primary) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:hover:not(:disabled)) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:focus:not(:disabled)) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:active:not(:disabled)) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}
</style>

<style>
/* Confirm 弹窗按钮样式 - 全局样式确保生效（confirm弹窗是动态创建的） */
.ant-modal-confirm .ant-modal-confirm-btns .ant-btn {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-default {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:focus:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:active:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}
</style>
